<script setup lang="ts">
useHead({
  titleTemplate(title) {
    return title ? title + " - Notary.io" : "Notary.io";
  },
});

const toast = useMessage();
const route = useRoute();

/** Signers and witnesses check in on the notary's status badges. */
const isParticipantRoute = computed(() => /^\/sessions\/[^/]+\/(client|witness)\//.test(route.path));

const logSomeError = (error: any) => {
  console.error("Error captured", error);
  toast.message({
    title: "Error",
    message: error,
    type: "error",
  });
};
</script>

<template>
  <NuxtLoadingIndicator color="#06C972" />
  <CommonAppUpdateBanner />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <CommonToast />
  <ClientOnly>
    <SessionParticipantHeartbeat v-if="isParticipantRoute" />
  </ClientOnly>
</template>
